const annahmePrintHeights = new Map();

window.addEventListener('beforeprint', () => {
	document.body.classList.add('annahme-print-measure');
	const ruler = document.createElement('div');
	ruler.style.cssText = 'position:absolute;visibility:hidden;width:100mm;height:0;pointer-events:none';
	document.body.appendChild(ruler);
	const pixelsPerMm = ruler.getBoundingClientRect().width / 100;
	ruler.remove();

	document.querySelectorAll('section.annahme form').forEach(form => {
		form.style.setProperty('--annahme-print-scale', '1');
		let headline = null;
		form.querySelectorAll('h2, .line:not(.button)').forEach(row => {
			if (row.tagName === 'H2') {
				headline = row;
				headline.classList.add('print-hidden');
				return;
			}
			const field = row.querySelector('input, textarea');
			const filled = field && (field.type === 'checkbox' ? field.checked : field.value.trim() !== '');
			row.classList.toggle('print-hidden', !filled);
			if (filled && headline) headline.classList.remove('print-hidden');
		});

		form.querySelectorAll('.line:not(.print-hidden) textarea').forEach(field => {
			if (!annahmePrintHeights.has(field)) annahmePrintHeights.set(field, field.style.height);
			field.style.height = 'auto';
			const style = getComputedStyle(field);
			const borders = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			field.style.height = (field.scrollHeight + borders) + 'px';
		});

		// Reserve space for browser headers, footers and pagination rounding.
		const height = form.getBoundingClientRect().height;
		const availableHeight = 258 * pixelsPerMm;
		let scale = height > 0 ? Math.min(1, availableHeight / height) : 1;
		form.style.setProperty('--annahme-print-scale', String(scale));
		const scaledHeight = form.getBoundingClientRect().height;
		if (scaledHeight > availableHeight) {
			scale *= availableHeight / scaledHeight;
			form.style.setProperty('--annahme-print-scale', String(scale));
		}
	});
});

window.addEventListener('afterprint', () => {
	document.body.classList.remove('annahme-print-measure');
	annahmePrintHeights.forEach((height, field) => { field.style.height = height; });
	annahmePrintHeights.clear();
	document.querySelectorAll('section.annahme form').forEach(form => {
		form.style.removeProperty('--annahme-print-scale');
	});
});

document.addEventListener('click', event => {
	if (event.target.closest('section.annahme [data-print]')) window.print();
});
